/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cut_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Cut selected events or text" |
*
* @param {Cut_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cut_aria_label = /** @type {((inputs?: Cut_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cut_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couper les evenements ou le texte selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Ereignisse oder Texte ausschneiden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Taglia gli eventi o il testo selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вырезать выделенные события или текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cortar eventos o texto seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("剪切选定的事件或文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントまたはテキストを切り取る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं या पाठ को काटें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recortar eventos ou texto selecionados")
	return /** @type {LocalizedString} */ ("Cut selected events or text")
});